import { titleCase } from "@memorang/helpers/common";
import { issues } from "./issues-data";

export const mockedIssues = [
	{
		...issues?.[0],
		title: "Latest Issue",
		articles: issues?.[0]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[1],
		title: `Previous Issue (Vol. ${issues?.[1]?.volume} No .${issues?.[1]?.id} • ${issues?.[1]?.date})`,
		articles: issues?.[1]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[2],
		title: `Vol. ${issues?.[2]?.volume} No. ${issues?.[2]?.id} • ${issues?.[2]?.date}`,
		articles: issues?.[2]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[3],
		title: `Vol. ${issues?.[3]?.volume} No. ${issues?.[3]?.id} • ${issues?.[3]?.date}`,
		articles: issues?.[3]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[4],
		title: `Vol. ${issues?.[4]?.volume} No. ${issues?.[4]?.id} • ${issues?.[4]?.date}`,
		articles: issues?.[4]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[5],
		title: `Vol. ${issues?.[5]?.volume} No. ${issues?.[5]?.id} • ${issues?.[5]?.date}`,
		articles: issues?.[5]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[6],
		title: `Vol. ${issues?.[6]?.volume} No. ${issues?.[6]?.id} • ${issues?.[6]?.date}`,
		articles: issues?.[6]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[7],
		title: `Vol. ${issues?.[7]?.volume} No. ${issues?.[7]?.id} • ${issues?.[7]?.date}`,
		articles: issues?.[7]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[8],
		title: `Vol. ${issues?.[8]?.volume} No. ${issues?.[8]?.id} • ${issues?.[8]?.date}`,
		articles: issues?.[8]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
	{
		...issues?.[9],
		title: `Vol. ${issues?.[9]?.volume} No. ${issues?.[9]?.id} • ${issues?.[9]?.date}`,
		articles: issues?.[9]?.articles.slice(0, 6).map((article) => {
			return {
				...article,
				id: Number(article.id),
				description: titleCase(article.type),
				articleType: article.type,
				type: "article",
			};
		}),
	},
];

export const tagIconUrlMap: Record<string, string> = {
	"Pain Management":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Pain_Management%20Background%20Removed.png?t=2024-12-04T04%3A56%3A07.527Z",
	Pediatrics:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Pediatrics%20Background%20Removed.png?t=2024-12-04T04%3A56%3A22.695Z",
	"Hand & Wrist":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Hand_And_Wrist%20Background%20Removed.png?t=2024-12-04T04%3A56%3A32.709Z",
	"Foot & Ankle":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Foot_And_Ankle%20Background%20Removed.png?t=2024-12-04T04%3A56%3A40.944Z",
	Oncology:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Oncology%20Background%20Removed.png?t=2024-12-04T04%3A56%3A52.746Z",
	Hip: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Hip%20Background%20Removed.png?t=2024-12-04T04%3A57%3A03.820Z",
	Infection:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Infection%20Background%20Removed.png?t=2024-12-04T04%3A57%3A18.595Z",
	Spine:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Spine%20Background%20Removed.png?t=2024-12-04T04%3A57%3A27.049Z",
	Trauma:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Trauma%20Background%20Removed.png?t=2024-12-04T04%3A57%3A36.597Z",
	"Shoulder & Elbow":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Shoulder_And_Elbow%20Background%20Removed.png?t=2024-12-04T04%3A57%3A44.448Z",
	Knee: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Knee%20Background%20Removed.png?t=2024-12-04T04%3A57%3A52.598Z",
	Sports:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Sports_Medicine%20Background%20Removed.png?t=2024-12-04T04%3A58%3A02.680Z",
	"Basic Science":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Basic_Science%20Background%20Removed.png",
	"Orthopaedic Essentials":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Orthopedic_Essentials%20Background%20Removed.png?t=2024-12-04T04%3A58%3A20.301Z",
	"Education & Training":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Education_And_Training%20Background%20Removed%20Background%20Removed.png?t=2024-12-04T04%3A58%3A31.424Z",
};
